import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import { TurnStateEnum } from '../../../Enums/TurnStateEnum';
import { useContext, useEffect, useState } from 'react';
import { AlertContext } from '../../../contexts/AlertContext';
import { GameContext } from '../../../contexts/GameContext';

interface TurnActionButtonProps {
    text1: string;
    text2: string;
    allPlayersReady?: boolean;
}
const TurnActionButton = (props: TurnActionButtonProps) => {
    const backgroundButton = 'url(/images/buttons/menuButton2.png)';
    const backgroundButtonHover = 'url(/images/buttons/menuButton2_hover.png)';
    const backgroundButtonDisabled = 'url(/images/buttons/menuButton2_disabled.png)';

    const gameContext = useContext(GameContext);
    const alertContext = useContext(AlertContext);
    const [loading, setLoading] = useState(false);
    const [loadingNewTurn, setLoadingNewTurn] = useState(false);

    useEffect(() => {
        setLoading(false);
        setLoadingNewTurn(false);
    }, [gameContext.currentTurn?.turnState]);

    const UpdateTurnState = async () => {
        const wantedTurn = (): TurnStateEnum => {
            if (gameContext.currentTurn!.turnState === TurnStateEnum.waitingTurnHolderValidation) {
                return TurnStateEnum.waitingEndOfTurnValidation;
            }

            if (gameContext.currentTurn!.turnState === TurnStateEnum.waitingEndOfTurnValidation) {
                return TurnStateEnum.turnFinished;
            }

            if (gameContext.currentTurn!.turnState === TurnStateEnum.turnFinished) {
                return TurnStateEnum.waitingEndOfTurnValidation;
            }

            return TurnStateEnum.waitingTurnHolderValidation;
        };

        const wantedTurnValue = wantedTurn();

        if (gameContext.currentTurn!.turnState !== TurnStateEnum.turnFinished) {
            await gameContext
                .getClient()
                .UpdateTurnState(gameContext.currentTurn!.turnState, wantedTurnValue)
                .then((result) => {
                    if (!result.success) {
                        alertContext?.setAlertMessage(result.errorMessage);
                    }
                });
        } else {
            await gameContext.getClient().CreateNewTurn();
        }
    };

    const handleClick = async () => {
        setLoading(true);
        if (gameContext.currentTurn!.turnState === TurnStateEnum.turnFinished) {
            setLoadingNewTurn(true);
        }
        await UpdateTurnState();
    };

    const noBet = gameContext.currentTurn?.turnState === TurnStateEnum.waitingTurnHolderValidation
        && (gameContext.currentTurn?.turnHolderBet === undefined || gameContext.currentTurn?.turnHolderBet === '');
    const waitingForReady = gameContext.currentTurn?.turnState === TurnStateEnum.waitingEndOfTurnValidation && !props.allPlayersReady;
    const isDisabled = noBet || waitingForReady || loading;

    return (
        <Button
            disabled={isDisabled}
            onClick={handleClick}
            sx={{
                width: 'auto',
                height: 'auto',
                backgroundImage: isDisabled ? backgroundButtonDisabled : backgroundButton,
                backgroundSize: 'cover',
                backgroundPosition: 'left',
                backgroundRepeat: 'no-repeat',
                '&:hover': {
                    backgroundImage: isDisabled ? backgroundButtonDisabled : backgroundButtonHover,
                    cursor: isDisabled ? 'not-allowed' : 'pointer'
                },
                opacity: isDisabled ? 0.8 : 1
            }}
        >
            {loadingNewTurn ? (
                <CircularProgress size={32} sx={{ color: 'black' }} />
            ) : (
                <Stack spacing={2}>
                    <Typography variant={'h6'} color={isDisabled ? 'gray' : 'black'} textTransform="none">
                        {props.text1}
                    </Typography>
                    {props.text2 && (
                        <Typography variant="h5" color={isDisabled ? 'gray' : 'black'} textTransform="none">
                            {props.text2}
                        </Typography>
                    )}
                </Stack>
            )}
        </Button>
    );
};

export default TurnActionButton;
